const subjectsData = escalatedComplaintsEnabled => {
  const options = {
    id: "subjects",
    type: "select",
    analyticsEvent: {
      action: "email.topic",
      topic: true,
    },
    select: {
      label: "What is your email about?",
      options: [
        {
          value: null,
          label: "Select a subject",
        },
        {
          value: "productAndStockInformation",
          label: "Product & stock information",
        },
        {
          value: "myJLMembership",
          label: "my John Lewis membership",
        },
        {
          value: "problemsWithProduct",
          label: "Problems with a product",
        },
        {
          value: "returns",
          label: "Returns",
        },
        {
          value: "refunds",
          label: "Refunds",
        },
        {
          value: "orderQuery",
          label: "Change or cancel an order",
        },
        {
          value: "deliveryQuery",
          label: "Delivery",
        },
        {
          value: "giftCard",
          label: "Gift cards & e-gift cards",
        },
        {
          value: "shopLostProperty",
          label: "Lost property in a shop",
        },
        {
          value: "websiteFeedback",
          label: "Website feedback",
        },
      ],
    },
  };

  if (escalatedComplaintsEnabled) {
    const newOptions = [
      {
        value: "damagePropertyOrPersonalInjury",
        label: "Damage to Property or Personal Injury",
      },
      {
        value: "financialService",
        label: "John Lewis Financial services",
      },
    ];
    options.select.options.push(...newOptions);
  }

  return options;
};

export default subjectsData;
